<!-- results-table.component.html -->
<h1 mat-dialog-title>Seleccionar nodo de estructura jerarquica </h1>
<div mat-dialog-content>

  <mat-form-field class="select-list" *ngIf="!tieneEstructuraBase">
    <mat-label>Estructura Jerarquica</mat-label>
    <mat-select [(ngModel)]="estructura" class="roleSelect" (selectionChange)="loadNodos()">
        <mat-option *ngFor="let estructura of estructuras" [value]="estructura">
            {{estructura.nombre}}
        </mat-option>
    </mat-select>
  </mat-form-field>

    <div class="content-card">

        <!-- CONTENT TOOLBAR -->
        <div class="toolbar px-24 py-8">
            <span>Nodos</span>
        </div>
        <!-- / CONTENT TOOLBAR -->

        <!-- CONTENT -->
        <div class="content p-24">



            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
              <!-- This is the tree node template for leaf nodes -->
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                <!-- use a disabled button to provide padding for tree leaf -->
                <button mat-icon-button disabled></button>
                <span class="px-20">{{node.name}}</span>
                <button mat-button (click)="doAction(node)" mat-flat-button color="primary" class="add-row" *ngIf="node.enabled">
                  <mat-icon>done</mat-icon>
                </button>
              </mat-tree-node>
              <!-- This is the tree node template for expandable nodes -->
              <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                <button mat-icon-button matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                <span class="px-20">{{node.name}}</span>
                <button mat-button (click)="doAction(node)" mat-flat-button color="primary" class="add-row" *ngIf="node.enabled">
                  <mat-icon>done</mat-icon>
                </button>
              </mat-tree-node>
            </mat-tree>

        </div>


    </div>


</div>
<div mat-dialog-actions>
  <!--<button mat-button (click)="doAction()">{{action | translate}}</button>-->
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">Cancelar</button>
</div>
